export default [
  {
    "id": "mat-enem-0812",
    "numero": 2312,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "A prefeitura de uma cidade detectou que as \ngalerias pluviais, que possuem seção transver-\nsal na forma de um quadrado de lado 2 m, são \ninsuficientes para comportar o escoamento da \nágua em caso de enchentes. Por essa razão, \nessas galerias foram reformadas e passaram a \nter seções quadradas de lado igual ao dobro \ndas anteriores, permitindo uma vazão de 400 \nm3/s. O cálculo da vazão V (em m3/s) é dado \npelo produto entre a área por onde passa a \nágua (em m2) e a velocidade da água (em m/s). \n \nSupondo que a velocidade da água não se alte-\nrou, qual era a vazão máxima nas galerias antes \ndas reformas? \nA) 25 m3/s \nB) 50 m3/s \nC) 100 m3/s \nD) 200 m3/s \nE) 300 m3/s",
    "alternativas": {
      "B": "50 m3/s",
      "C": "100 m3/s",
      "E": "300 m3/s",
      "A": "25 m3/s"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 812,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0813",
    "numero": 2313,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "Um artista utilizou uma caixa cúbica transparen-\nte para a confecção de sua obra, que consistiu \nem construir um polígono IMNKPQ, no formato \nde um hexágono regular, disposto no interior da \ncaixa. Os vértices desse polígono estão situa-\ndos em pontos médios de arestas da caixa. Um \nesboço da sua obra pode ser visto na figura. \n \n \n \nConsiderando as diagonais do hexágono, distin-\ntas de IK, quantas têm o mesmo comprimento \nde IK? \n \nA) 1 \nB) 2 \nC) 4 \nD) 8 \nE) 9",
    "alternativas": {
      "E": "9",
      "A": "1",
      "B": "2",
      "C": "4"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 813,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0814",
    "numero": 2314,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "Um gesseiro que trabalhava na reforma de uma \ncasa lidava com placas de gesso com formato \nde pentágono regular quando percebeu que \numa peça estava quebrada, faltando uma parte \ntriangular, conforme mostra a figura. \n \n \nPara recompor a peça, ele precisou refazer a \nparte triangular que faltava e, para isso, anotou \nas medidas dos ângulos x = EÂD, y =\nA\nD\nE ˆ\n e z = \nAÊD do triângulo ADE. \n \nAs medidas x, y e z, em graus, desses ângulos \nsão, respectivamente, \n \nA) 18, 18 e 108 \nB) 24, 48 e 108 \nC) 36, 36 e 108 \nD) 54, 54 e 72 \nE) 60, 60 e 60",
    "alternativas": {
      "D": "54, 54 e 72",
      "A": "18, 18 e 108",
      "B": "24, 48 e 108",
      "C": "36, 36 e 108"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 814,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0815",
    "numero": 2315,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "A volemia (V) de um indivíduo é a quantidade \ntotal de sangue em seu sistema circulatório \n(coração, artérias, veias e capilares).  \n \nEla é útil quando se pretende estimar o número \ntotal (N) de hemácias de uma pessoa, a qual é \nobtida multiplicando-se a volemia (V) pela con-\ncentração (C) de hemácias no sangue, isto é,   \nN = V x C.  \n \nNum adulto normal essa concentração é de \n5200000 hemácias por mL de sangue, condu-\nzindo a grandes valores de N. Uma maneira \nadequada de informar essas grandes quantida-\ndes é utilizar a notação científica, que consiste \nem expressar N na forma N = Q x 10n, sendo 1 \n≤ Q < 10 e n um número inteiro. Considere um \nadulto normal, com volemia de 5000 mL. \n \n(http://perfline.com. Acesso em: 23 fev. 2013 - adp) \n \nQual a quantidade total de hemácias desse \nadulto, em notação científica? \n \nA) 2,6 x 10-10 \nB) 2,6 x 10-9 \nC) 2,6 x 109 \nD) 2,6 x 1010 \nE) 2,6 x 1011",
    "alternativas": {
      "E": "2,6 x 1011",
      "B": "2,6 x 10-9",
      "C": "2,6 x 109",
      "D": "2,6 x 1010"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 815,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0816",
    "numero": 2316,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "Em um mapa cartográfico, cuja escala é \n1:30000 as cidades A e B distam entre si, em \nlinha reta, 5cm. Um novo mapa, dessa mesma \nregião, será construído na escala 1:20000. \n \nNesse novo mapa cartográfico, a distância em \nlinha reta entre as cidades A e B, em centíme-\ntro, será igual a: \n \nA) 1,50. \nB) 3,33. \nC) 3,50. \nD) 6,50. \nE) 7,50.",
    "alternativas": {
      "A": "1,50.",
      "C": "3,50.",
      "D": "6,50.",
      "E": "7,50."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 816,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0817",
    "numero": 2317,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "Uma empresa pretende adquirir uma nova impressora com o objetivo de suprir um dos seus departa-\nmentos que tem uma demanda grande por cópias. Para isso, efetuou-se uma pesquisa de mercado que \nresultou em três modelos de impressora distintos, que se diferenciam apenas pelas seguintes caracterís-\nticas: \n \n \n \nPara facilitar a tomada de decisão, o departamento informou que sua demanda será de, exatamente, \n50000 cópias. Assim, deve-se adquirir a impressora: \n \nA) A ou B, em vez de C. \nB) B, em vez de A ou C. \nC) A, em vez de B ou C. \nD) C, em vez de A ou B. \nE) A ou C, em vez de B.",
    "alternativas": {
      "B": "B, em vez de A ou C.",
      "D": "C, em vez de A ou B.",
      "E": "A ou C, em vez de B.",
      "A": "A ou B, em vez de C."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 817,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0818",
    "numero": 2318,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "O quadro apresenta dados sobre viagens distintas, realizadas com o mesmo veículo, por diferentes mo-\ntoristas. Em cada viagem, o veículo foi abastecido com combustível de um preço diferente e trafegou \ncom uma velocidade média distinta. \n \n \n \nSabe-se que esse veículo tem um rendimento de 15 km por litro de combustível se trafegar com veloci-\ndade média abaixo de 75 km/h. Já se trafegar com velocidade média entre 75 km/h e 80 km/h, o rendi-\nmento será de 16 km por litro de combustível. Trafegando com velocidade média entre 81 km/h e 85 \nkm/h, o rendimento será de 12 km por litro de combustível e, acima dessa velocidade média, o rendimen-\nto cairá para 10 km por litro de combustível. \n \nO motorista que realizou a viagem que teve o menor custo com combustível foi o de número: \n \nA) 1 \nB) 2 \nC) 3 \nD) 4 \nE) 5",
    "alternativas": {
      "C": "3",
      "D": "4",
      "A": "1",
      "B": "2"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 818,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0819",
    "numero": 2319,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "Uma professora de matemática organizou uma \natividade associando um ábaco a três dados de \ndiferentes formatos: um cubo com faces nume-\nradas de 1 a 6, associadas à haste C, um octa-\nedro com faces numeradas de 1 a 8, associadas \nà haste D, e um dodecaedro com faces nume-\nradas de 1 a 12, associadas à haste U. Inicial-\nmente, as hastes do ábaco encontram-se vazi-\nas. As letras C, D, e U estão associadas a cen-\ntenas, dezenas e unidades, respectivamente. A \nhaste UM representa unidades de milhar. \n \nRegras do jogo: são jogados os três dados jun-\ntos e, a cada jogada, colocam-se bolinhas nas \nhastes, correspondendo às quantidades apre-\nsentadas nas faces voltadas para cima de cada \nlado, respeitando a condição \"nunca dez\", ou \nseja, em cada haste podem ficar, no máximo, \nnove bolinhas. Assim, toda vez que a quantida-\nde de bolinhas em alguma haste dor superior a \nnove, dez delas são retiradas dessa haste e \numa bolinha é colocada na haste imediatamente \nà esquerda. Bolinhas, em quantidades iguais \naos números obtidos na face superior de dados, \nna segunda jogada, são acrescentadas às has-\ntes correspondentes, que contêm o resultado da \nprimeira jogada. \n \nIniciada a atividade, um aluno jogou os dados \nduas vezes. Na primeira vez, as quantidades \ndas faces voltadas para cima foram colocadas \nnas hastes. Nesta jogada, no cubo, no octaedro \ne no dodecaedro, as faces voltadas para cima \nforma, respectivamente, 6, 8 e 11 (figura 1). \n \nNa segunda vez, o aluno jogou os dados e adi-\ncionou as quantidades correspondentes, nas \nrespectivas hastes. O resultado está represen-\ntado no ábaco da figura 2. \n \n \nDe acordo com a descrição, as faces voltadas \npara cima no cubo, no octaedro e no dodecae-\ndro, na segunda jogada foram, respectivamente, \n \nA) 4, 2 e 9. \nB) 4, 3 e 9. \nC) 4, 3 e 10. \nD) 5, 3 e 10. \nE) 5, 4 e 9.",
    "alternativas": {
      "C": "4, 3 e 10.",
      "D": "5, 3 e 10.",
      "A": "4, 2 e 9.",
      "B": "4, 3 e 9."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 819,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0820",
    "numero": 2320,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "Uma partida de voleibol entre Brasil e Itália foi \ndecidida em cinco sets. As pontuações do jogo \nestão descritas na tabela. \n \n \n \nNessa partida, a mediana dos pontos obtidos \npor set pelo time da Itália foi igual a: \n \nA) 16. \nB) 20. \nC) 21. \nD) 23. \nE) 26.",
    "alternativas": {
      "E": "26.",
      "B": "20.",
      "C": "21.",
      "D": "23."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 820,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0821",
    "numero": 2321,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "Um arquiteto deseja construir um jardim circular \nde 20 m de diâmetro. Nesse jardim, uma parte \ndo terreno será reservada para pedras orna-\nmentais. Essa parte terá a forma de um quadra-\ndo inscrito na circunferência, como mostrado na \nfigura. Na parte compreendida entre o contorno \nda circunferência e a parte externa ao quadra-\ndo, será colocado terra vegetal. Nessa parte do \njardim, serão usados 15 kg de terra para cada \nm2. A terra vegetal é comercializada em sacos \ncom exatos 15 kg de cada. Use 3 como valor \naproximado para π. \n \n \nO número mínimo de sacos de terra vegetal \nnecessários para cobrir a parte descrita do jar-\ndim é: \n \nA) 100. \nB) 140. \nC) 200. \nD) 800. \nE) 1000.",
    "alternativas": {
      "A": "100.",
      "C": "200.",
      "D": "800.",
      "E": "1000."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 821,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0822",
    "numero": 2322,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "Tradicionalmente uma pizza média de formato \ncircular tem diâmetro de 30cm e é dividida em 8 \nfatias iguais (mesma área). Uma família, ao se \nreunir para o jantar, fará uma pizza de formato \ncircular e pretende dividi-la em 10 fatias também \niguais. Entretanto, eles desejam que cada fatia \ndessa pizza tenha o mesmo tamanho (mesma \nárea) de cada fatia de pizza média quando divi-\ndida em 8 fatias iguais. \n \nQual o valor mais próximo do raio com que deve \nser feita a pizza, em centímetro, para que eles \nconsigam dividi-la de forma pretende? \n \nUse 2,2 como aproximação para \n5 . \n \nA) 15,00 \nB) 16,50 \nC) 18,75 \nD) 33,00 \nE) 37,50",
    "alternativas": {
      "A": "15,00",
      "B": "16,50",
      "D": "33,00",
      "E": "37,50"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 822,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0823",
    "numero": 2323,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "Em sua vez de jogar, um jogador precisa dar \numa tacada na bola branca, de forma a acertar \na bola 9 e fazê-la cair em uma das caçapas de \numa mesa de bilhar. Como a bola 8 encontra-se \nentre a bola branca e a bola 9, esse jogador \nadota a estratégia de dar uma tacada na bola \nbranca em direção a uma das laterais da mesa, \nde forma que, ao rebater, ela saia em uma traje-\ntória retilínea, formando um ângulo de 90º com \na trajetória da tacada, conforme ilustrado na \nfigura. \n \n \n \nCom essa estratégia, o jogador conseguiu en-\ncaçapar a bola 9. Considere um sistema carte-\nsiano de eixos sobre o plano da mesa, no qual o \nponto de contato da bola com a mesa define \nsua posição nesse sistema.  \n \nAs coordenadas do ponto que representa a bola \n9 são (3 ; 3), o centro da caçapa de destino tem \ncoordenadas (6 ; 0) e a abscissa da bola branca \né 0,5, como representados na figura. \nSe a estratégia deu certo, a ordenada da posi-\nção original da bola branca era: \n \nA) 1,3. \nB) 1,5 \nC) 2,1. \nD) 2,2. \nE) 2,5.",
    "alternativas": {
      "E": "2,5.",
      "A": "1,3.",
      "B": "1,5",
      "C": "2,1."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 823,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0825",
    "numero": 2325,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "Em alguns supermercados, é comum a venda \nde produtos em atacado com preços inferiores \naos habituais. Um desses supermercados \nanunciou a venda de sabonetes em cinco op-\nções de pacotes diferentes. Segue a descrição \ndesses pacotes com as respectivas quantidades \ne preços. \n \nPacote I: 3 unidades por R$ 2,10; \nPacote II: 4 unidades por R$ 2,60; \nPacote III: 5 unidades por R$ 3,00; \nPacote IV: 6 unidades por R$ 3,90; \nPacote V: 12 unidades por R$ 9,60. \n \nTodos os sabonetes que compõem esses paco-\ntes são idênticos. \nQual desses pacotes oferece o menor preço por \nsabonete? \n \nA) I \nB) II \nC) III \nD) IV \nE) V",
    "alternativas": {
      "E": "V",
      "B": "II",
      "C": "III",
      "D": "IV"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 825,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0826",
    "numero": 2326,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "Um ciclista A usou uma bicicleta com rodas com \ndiâmetros medindo 60cm e percorreu, com ela, \n10km. Um ciclista B usou outra bicicleta com \nrodas cujos diâmetros mediam 40cm e percor-\nreu, com ela, 5km. \n \nConsidere 3,14 como aproximação para π. \n \nA relação entre o número de voltas efetuadas \npelas rodas da bicicleta do ciclista A e o número \nde voltas efetuadas pelas rodas da bicicleta do \nciclista B é dada por: \n \nA) 1/2 \nB) 2/3 \nC) 3/4 \nD) 4/3 \nE) 3/2",
    "alternativas": {
      "E": "3/2",
      "A": "1/2",
      "C": "3/4",
      "D": "4/3"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 826,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0828",
    "numero": 2328,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "Segundo o Compromisso Empresarial para Re-\nciclagem (Cempre), o volume de lixo urbano \nreciclado passou de 5 milhões de toneladas, em \n2003, para 7,1 milhões de toneladas, em 2008.  \n \nNesse mesmo período, o número de municípios \ncom coleta seletiva passou de 653 para 1004. \nEsperava-se, durante este período, um aumento \nde pelo menos 40% no volume de lixo urbano \nreciclado e de 60% no número de municípios \ncom coleta seletiva. \n \n(Disponível em: http://revistaepoca.globo.com.  \nAcesso em: 31 jul. 2012) \n \nConsiderando os valores apresentados para o \nperíodo de 2003 a 2008, os aumentos espera- \ndos no volume de lixo urbano reciclado e no \nnúmero de municípios com coleta seletiva: \n \nA) não foram atingidos, pois o aumento no vo-\nlume de lixo urbano reciclado foi de 30%, e no \nnúmero de municípios com coleta seletiva foi de \n30%. \nB) não foram atingidos, pois o aumento no vo-\nlume de lixo urbano reciclado foi de 30%, e no \nnúmero de municípios com coleta seletiva foi de \n35%. \nC) foram atingidos apenas parcialmente, pois os \naumentos no volume de lixo urbano reciclado e \nno número de municípios com coleta seletiva \nforam de 42%. \nD) foram atingidos apenas parcialmente, pois o \naumento no volume de lixo urbano reciclado foi \nde 42%, e no número de municípios com coleta \nseletiva foi de 35%. \nE) foram atingidos apenas parcialmente, pois o \naumento no volume de lixo urbano reciclado foi \nde 42%, e no número de municípios com coleta \nseletiva foi de 54%.",
    "alternativas": {
      "A": "não foram atingidos, pois o aumento no vo- lume de lixo urbano reciclado foi de 30%, e no número de municípios com coleta seletiva foi de 30%.",
      "B": "não foram atingidos, pois o aumento no vo- lume de lixo urbano reciclado foi de 30%, e no número de municípios com coleta seletiva foi de 35%.",
      "C": "foram atingidos apenas parcialmente, pois os aumentos no volume de lixo urbano reciclado e no número de municípios com coleta seletiva foram de 42%.",
      "E": "foram atingidos apenas parcialmente, pois o aumento no volume de lixo urbano reciclado foi de 42%, e no número de municípios com coleta seletiva foi de 54%."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 828,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0829",
    "numero": 2329,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "Possivelmente você já tenha escutado a per-\ngunta: \"O que pesa mais, 1 kg de algodão ou 1 \nkg de chumbo?\". É óbvio que ambos têm a \nmesma massa, portanto, o mesmo peso. O tru-\nque dessa pergunta é a grande diferença de \nvolumes que faz, enganosamente, algumas \npessoas pensarem que pesa mais quem tem \nmaior volume, levando-as a responderem que é \no algodão. A grande diferença de volumes de-\ncorre da densidade (p) dos materiais, ou seja, a \nrazão entre suas massas e seus respectivos \nvolumes, que pode ser representada pela ex-\npressão: p = m/v. \n \nConsidere as substâncias A, B, C, D e E repre-\nsentadas no sistema cartesiano (volume x mas-\nsa) a seguir: \n \n \nA substância com maior densidade é: \n \nA) A. \nB) B. \nC) C. \nD) D. \nE) E.",
    "alternativas": {
      "B": "B.",
      "C": "C.",
      "D": "D.",
      "A": "A."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 829,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0830",
    "numero": 2330,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "Um casal e seus dois filhos saíram, com um \ncorretor de imóveis, com a intenção de comprar \num lote onde futuramente construiriam sua resi-\ndência. No projeto da casa, que esta família tem \nem mente, irão necessitar de uma área de pelo \nmenos 400m2. Após algumas avaliações, fica-\nram de decidir entre os lotes 1 e 2 da figura, em \nforma de paralelogramos, cujos preços são \nR$100000,00 e R$150000,00, respectivamente. \n \n \n \nUse \n3 /2, 1/2 e 1,7 como aproximações, res-\npectivamente, para sen(60º), cos(60º) e \n3 . \n \nPara colaborarem na decisão, os envolvidos \nfizeram as seguintes argumentações: \n \nPai: devemos comprar o Lote 1, pois como uma \nde suas diagonais é maior do que as diagonais \ndo Lote 2, o Lote 1 também terá maior área; \n \nMãe: Se desconsiderarmos os preços, podere-\nmos comprar qualquer lote para executar nosso \nprojeto, pois tendo ambos o mesmo perímetro, \nterão também a mesma área; \n \nFilho 1: Devemos comprar o Lote 2, pois é o \núnico que tem área suficiente para a execução \ndo projeto; \n \nFilho 2: Devemos comprar o Lote 1, pois como \nos dois lotes possuem lados de mesma medida, \nterão também a mesma área, porém o Lote 1 é \nmais barato; \n \nCorretor: Vocês devem comprar o Lote 2, pois \né o que tem menor custo por metro quadrado. \nA pessoa que argumentou corretamente para a \ncompra do terreno foi o(a): \n \nA) pai. \nB) mãe. \nC) filho 1. \nD) filho 2. \nE) corretor.",
    "alternativas": {
      "B": "mãe.",
      "C": "filho 1.",
      "D": "filho 2.",
      "E": "corretor."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 830,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0831",
    "numero": 2331,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "O técnico de um time de voleibol registra o nú-\nmero de jogadas e de acertos, por atleta, em \ncada fundamento, para verificar os desempe-\nnhos dos jogadores. Para que o time tenha um \nmelhor aproveitamento no fundamento bloqueio, \nele decide substituir um dos jogadores em qua-\ndra por um dos que estão no banco de reservas. \n \nO critério a ser adotado é o de escolher o atleta \nque, no fundamento bloqueio, tenha apresenta-\ndo o maior número de acertos em relação ao \nnúmero de jogadas de que tenha participado. \nOs registros dos cinco atletas que se encontram \nno banco de reservas, nesse fundamento, estão \napresentados no quadro. \n \n \n \nQual dos atletas do banco de reservas o treina-\ndor deve colocar em quadra? \n \nA) I \nB) II \nC) III \nD) IV \nE) V",
    "alternativas": {
      "E": "V",
      "A": "I",
      "C": "III",
      "D": "IV"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 831,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0832",
    "numero": 2332,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "Um semáforo é composto, geralmente, de três \ncírculos de luzes coloridas (vermelho, amarelo e \nverde). A cor vermelha indica que o veículo \ndeve estar parado e permanecer assim até que \na cor verde volte a acender. \n \nO gráfico apresenta a variação de velocidade de \num carro longo de um percurso de 15 minutos \nde duração, da residência de uma pessoa até \nseu local de trabalho. Durante esse percurso, o \ncarro parou somente nos semáforos existentes \nao longo de seu trajeto. \n \n \nEm quantos semáforos ele parou? \n \nA) 2 \nB) 4 \nC) 5 \nD) 6 \nE) 7",
    "alternativas": {
      "E": "7",
      "A": "2",
      "B": "4",
      "D": "6"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 832,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0833",
    "numero": 2333,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "O percentual da população brasileira conectada \nà internet aumentou nos anos de 2007 a 2011. \nConforme dados do Grupo Ipsos, essa tendên-\ncia de crescimento é mostrada no gráfico. \n \nBrasileiros Conectados à Internet \n \n \nSuponha que foi mantida, para os anos seguin-\ntes, a mesma taxa de crescimento registrada no \nperíodo 2007-2011. \n \nA estimativa para o percentual de brasileiros \nconectados à internet em 2013 era igual a: \n \nA) 56,40% \nB) 58,50% \nC) 60,60% \nD) 63,75% \nE) 72,00%",
    "alternativas": {
      "E": "72,00%",
      "A": "56,40%",
      "B": "58,50%",
      "C": "60,60%"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 833,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0834",
    "numero": 2334,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "O ato de medir consiste em comparar duas \ngrandezas de mesma espécie. Para medir com-\nprimentos existem diversos sistemas de medi-\ndas.  \n \nO pé, a polegada e a jarda, por exemplo, são \nunidades de comprimento utilizadas no Reino \nUnido e nos Estados Unidos. Um pé correspon-\nde a 1200/3937 metros ou doze polegadas, e \ntrês pés são uma jarda. \nUma haste com 3 jardas, 2 pés e 6 polegadas \ntem comprimento, em metro, mais próximo de: \n \nA) 1,0 \nB) 3,5 \nC) 10,0 \nD) 22,9 \nE) 25,3",
    "alternativas": {
      "A": "1,0",
      "B": "3,5",
      "C": "10,0",
      "D": "22,9"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 834,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0835",
    "numero": 2335,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "Observou-se que todas as formigas de um for-\nmigueiro trabalham de maneira ordeira e orga-\nnizada. Foi feito um experimento com duas for-\nmigas e os resultados obtidos foram esboçados \nem um plano cartesiano no qual os eixos estão \ngraduados em quilômetros. As duas formigas \npartiram juntas do ponto O, origem do plano \ncartesiano xOy. Uma delas caminhou horizon-\ntalmente para o lado direito, a uma velocidade \nde 4 km/h. A outra caminhou verticalmente para \ncima, à velocidade de 3 Km/h. \n \nApós 2 horas de movimento, quais as coorde-\nnadas cartesianas das posições de cada formi-\nga? \n \nA) (8;0) e (0;6) \nB) (4:0) e (0;6). \nC) (4;0) e (0;3). \nD) (0;8) e (6;0). \nE) (0;4) e (3;0).",
    "alternativas": {
      "D": "(0;8) e (6;0).",
      "E": "(0;4) e (3;0).",
      "A": "(8;0) e (0;6)",
      "C": "(4;0) e (0;3)."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 835,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0836",
    "numero": 2336,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "Um produtor de café contratou uma empresa de \nconsultoria para avaliar as produções de suas \ndiversas fazendas. No relatório entregue consta \nque a variância das produtividades das fazen-\ndas foi igual a 9216 kg2/ha2. Esse produtor pre-\ncisa apresentar essa informação, mas sabe que \na saca de café tem 60kg, mas tem dúvidas em \ndeterminar o valor da variância em sacas2/ha2. \n \nA variância das produtividades das fazendas de \ncafé expressa em sacas2/ha2 é: \n \nA) 153,60. \nB) 12,39. \nC) 6,55. \nD) 2,56. \nE) 1,60.",
    "alternativas": {
      "C": "6,55.",
      "D": "2,56.",
      "E": "1,60.",
      "A": "153,60."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 836,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0837",
    "numero": 2337,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "Computadores utilizam, por padrão, dados em \nformato binário, em que cada dígito, denomina-\ndo bit, pode assumir dois valores (0 ou 1). Para \nrepresentação de caracteres e outras informa-\nções, é necessário fazer uso de uma sequência \nde bits, o byte. No passado, um byte era com-\nposto de 6 bits em alguns computadores, mas \natualmente tem-se a padronização que o byte é \num octeto, ou seja, uma sequência de 8 bits. \nEsse padrão permite representar apenas 28 \ninformações distintas. \n \nSe um novo padrão for proposto, de modo que \num byte seja capaz de representar pelo menos \n2560 informações distintas, o número de bits em \num byte deve passar de 8 para: \n \nA) 10. \nB) 12. \nC) 13. \nD) 18. \nE) 20.",
    "alternativas": {
      "E": "20.",
      "A": "10.",
      "B": "12.",
      "D": "18."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 837,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0838",
    "numero": 2338,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "Cinco máquinas de costura são utilizadas em \numa confecção de calças. O proprietário deseja \ncomprar mais uma dessas máquinas, idêntica a \numa das já existentes, devendo escolher a que \ntiver a maior média de produção por hora. Na \ntabela estão indicadas as quantidades de horas \ntrabalhadas e de calças confeccionadas por \ncada uma das máquinas em determinados perí-\nodos observados. \n \n \n \nA máquina a ser comprada deverá ser idêntica \nà: \n \nA) 1 \nB) 2 \nC) 3 \nD) 4 \nE) 5",
    "alternativas": {
      "E": "5",
      "A": "1",
      "B": "2",
      "C": "3"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 838,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0839",
    "numero": 2339,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "O presidente de um time de futebol quer contra-\ntar um atacante para seu elenco e um empresá-\nrio lhe ofereceu cinco jogadores. Ele deseja \ncontratar o jogador que obteve a maior média \nde gols nos anos de 2010 a 2013. \n \nO quadro apresenta o número de gols marcados \nnos anos de 2010 a 2013 por cada um dos cin-\ncos jogadores: I, II, III, IV e V. \n \n \nO presidente do time deve contratar o jogador: \n \nA) I \nB) II \nC) III \nD) IV \nE) V",
    "alternativas": {
      "A": "I",
      "B": "II",
      "C": "III",
      "D": "IV"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 839,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0840",
    "numero": 2340,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "Em um torneio interclasses de um colégio, vi-\nsando estimular o aumento do número de gols \nnos jogos de futebol, a comissão organizadora \nestabeleceu a seguinte forma de contagem de \npontos para cada partida: uma vitória vale três \npontos, um empate com gols vale dois pontos, \num empate sem gols vale um ponto e uma der-\nrota vale zero ponto. Após 12 jogos, um dos \ntimes obteve como resultados cinco vitórias e \nsete empates, dos quais, três sem gols. \n \nDe acordo com esses dados, qual foi o número \ntotal de pontos obtidos pelo time citado? \n \nA) 22 \nB) 25 \nC) 26 \nD) 29 \nE) 36",
    "alternativas": {
      "D": "29",
      "E": "36",
      "B": "25",
      "C": "26"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 840,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0841",
    "numero": 2341,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "Em um campeonato de futebol, a vitória vale 3 \npontos, o empate 1 ponto e a derrota zero pon-\nto. Ganha o campeonato o time que tiver maior \nnúmero de pontos. Em caso de empate no total \nde pontos, os times são declarados vencedores. \n \nOs times R e S são os únicos com chance de \nganhar o campeonato, pois ambos possuem 68 \npontos e estão muito à frente dos outros times. \nNo entanto, R e S não se enfrentarão na rodada \nfinal. \n \nOs especialistas em futebol arriscam as seguin-\ntes probabilidades para os jogos da última roda-\nda: \n- R tem 80% de chance de ganhar e 15% de \nempatar; \n- S tem 40% de chance de ganhar e 20% de \nempatar. \n \nSegundo as informações dos especialistas em \nfutebol, qual é a probabilidade de o time R ser o \núnico vencedor do campeonato? \n \nA) 32% \nB) 38% \nC) 48% \nD) 54% \nE) 57%",
    "alternativas": {
      "D": "54%",
      "E": "57%",
      "A": "32%",
      "C": "48%"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 841,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0842",
    "numero": 2342,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "A figura mostra a pirâmide de Quéops, também \nconhecida como a Grande Pirâmide. Esse é o \nmonumento mais pesado que já foi construído \npelo homem da Antiguidade. Possui aproxima-\ndamente 2,3 milhões de blocos de rocha, cada \num pesando em média 2,5 toneladas. Considere \nque a pirâmide de Quéops seja regular, sua \nbase seja um quadrado com lados medindo 214 \nm, as faces laterais sejam triângulos isósceles \ncongruentes e suas arestas laterais meçam \n204m. \n \n \n \n(Disponível em: www.mauroweigel.blogspot.com. \nAcesso em: 23 nov. 2011) \n \nO valor mais aproximado para a altura da pirâ-\nmide de Quéops, em metro, é: \n \nA) 97,0 \nB) 136,8 \nC) 173,7. \nD) 189,3. \nE) 240,0.",
    "alternativas": {
      "A": "97,0",
      "B": "136,8",
      "D": "189,3.",
      "E": "240,0."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 842,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0843",
    "numero": 2343,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "Os sólidos de Platão são poliedros convexos \ncujas faces são todas congruentes a um único \npolígono regular, todos os vértices têm o mes-\nmo número de arestas incidentes e cada aresta \né compartilhada por apenas duas faces. Eles \nsão importantes, por exemplo, na classificação \ndas formas dos cristais minerais e no desenvol- \nvimento de diversos objetos. Como todo polie-\ndro convexo, os sólidos de Platão respeitam a \nrelação de Euler V - A + F = 2, em que V, A e F \nsão os números de vértices, arestas e faces do \npoliedro, respectivamente. \n \nEm um cristal, cuja forma é a de um poliedro de \nPlatão de faces triangulares, qual é a relação \nentre o número de vértices e número de faces? \n \nA) 2V - 4F = 4 \nB) 2V - 2F = 4 \nC) 2V - F = 4 \nD) 2v + F = 4 \nE) 2V + 5F = 4",
    "alternativas": {
      "A": "2V - 4F = 4",
      "B": "2V - 2F = 4",
      "C": "2V - F = 4",
      "E": "2V + 5F = 4"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 843,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0844",
    "numero": 2344,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "O prédio de uma empresa tem cinco andares e, \nem cada andar, há dois banheiros masculinos e \ndois femininos. Em cada banheiro estão instala-\ndos dois recipientes para sabonete líquido com \numa capacidade de 200 mL (0,2 litro) cada um. \nOs recipientes dos banheiros masculinos são \nabastecidos duas vezes por semana e os ba-\nnheiros femininos, três vezes por semana, \nquando estão completamente vazios. O forne-\ncedor de sabonete líquido para a empresa ofe-\nrece cinco tipos de embalagens: I, II, III, IV e V, \ncom capacidades de 2L, 3L, 4L, 5L e 6L, res-\npectivamente. \n \nPara abastecer completamente os recipientes \nde sabonete líquido dos banheiros durante a \nsemana, a empresa planeja adquirir quatro em-\nbalagens de um mesmo tipo, de forma que não \nhaja sobras de sabonete. \n \nQue tipo de embalagem a empresa deve adqui-\nrir? \n \nA) I \nB) II \nC) III \nD) IV \nE) V",
    "alternativas": {
      "A": "I",
      "B": "II",
      "C": "III",
      "D": "IV"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 844,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0845",
    "numero": 2345,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "No início de janeiro de um determinado ano, \numa família decidiu economizaras férias de \njulho daquele ano, guardando uma quantia por \nmês. Eles decidiram que, em janeiro, guardari-\nam R$ 300,00 e, a partir de fevereiro, guardari-\nam, a cada mês, 20% a mais do que no mês \nanterior. \n \nQual foi o total economizado (em real) no pri-\nmeiro semestre do ano, abandonando, por arre-\ndondamento, possíveis casas decimais nesse \nresultado? \nA) 1800,00 \nB) 2100,00 \nC) 2160,00 \nD) 2978,00 \nE) 3874,00",
    "alternativas": {
      "D": "2978,00",
      "E": "3874,00",
      "B": "2100,00",
      "C": "2160,00"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 845,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0846",
    "numero": 2346,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "Na figura estão representadas, em um plano \ncartesiano, duas circunferências: C1 (de raio 3 e \ncentro O1) e C2 (de raio 1 e centro O2), tangen-\ntes entre si, e uma reta t tangente às duas cir-\ncunferências nos pontos P e Q. \n \n \n \nNessas condições, a equação da reta t é: \n \nA) y = - \n3  x + 3 \n3  \nB) y = - \n3 /3x + 3 \n3  \n \nC) y = - x + 4 \n \nD) y = - 2/3 x + 4 \n \nE) y = - 4/5 x + 4",
    "alternativas": {
      "A": "y = - 3 x + 3 3",
      "B": "y = - 3 /3x + 3 3",
      "D": "y = - 2/3 x + 4",
      "E": "y = - 4/5 x + 4"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 846,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0848",
    "numero": 2348,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "Em 20 de abril de 2010 ocorreu a explosão e \nafundamento de uma plataforma de petróleo \nsemissubmersível, no Golfo do México. O aci-\ndente ocasionou um dos maiores desastres \necológicos mundiais, devido ao derrame de \n780000m3 de óleo cru no mar, por um período \nde 87 dias, entre abril e julho de 2010.  \nFinalizado o vazamento, parte do óleo vazado \ncomeçou a ser queimado, diretamente, enquan-\nto que outra parte foi removida por coleta, atra-\nvés de barcos filtradores.  \n \nAs duas técnicas juntas retiravam, aproximada-\nmente, 480m3 de óleo por dia. Durante todo o \nperíodo de remoção foram retirados, no total, \napenas 66705m3 de óleo. Por recomendação de \nambientalistas, a retirada total de óleo não de-\nveria ultrapassar 300 dias. \n \n(Disponível em: www.popularmechanics. \n Acesso em: 26 fev. 2013 - adaptado) \n \nPara que todo o óleo derramado no Golfo pu-\ndesse ter sido retirado dentro do prazo reco-\nmendado pelos ambientalistas, qual deveria ser \nsido a taxa mínima de remoção de óleo, em \nmetro cúbico/dia? \n \nA) 1625 \nB) 2600 \nC) 3508 \nD) 5613 \nE) 8966",
    "alternativas": {
      "C": "3508",
      "E": "8966",
      "A": "1625",
      "B": "2600"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 848,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0849",
    "numero": 2349,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "Ano após ano, muitos brasileiros são vítimas de homicídio no Brasil. O gráfico apresenta a quantidade de \nhomicídios registrados no Brasil, entre os anos 2000 e 2009. \n \n \n \n(WAISELFISZ, J. J. Mapa da violência 2012. São Paulo: Instituto Sangari, 2011 - adaptado) \n \nSe o maior crescimento anual absoluto observado nessa série se repetisse de 2009 para 2010, então o \nnúmero de homicídios no Brasil ao final desse período seria igual a: \n \nA) 48839 \nB) 52755 \nC) 53840 \nD) 54017 \nE) 54103",
    "alternativas": {
      "B": "52755",
      "C": "53840",
      "D": "54017",
      "A": "48839"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 849,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0851",
    "numero": 2351,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "O quadro apresenta cinco cidades de um estado com seus respectivos números de habitantes e quanti-\ndade de pessoas infectadas com o vírus da gripe. Sabe-se que o governo desse estado destinará recur-\nsos financeiros a cada cidade, em valores proporcionais à probabilidade de uma pessoa, escolhida ao \nacaso na cidade, estar infectada. \n \n \n \nQual dessas cidades receberá maior valor de recursos financeiros? \n \nA) I \nB) II \nC) III \nD) IV \nE) V",
    "alternativas": {
      "C": "III",
      "D": "IV",
      "E": "V",
      "A": "I"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 851,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0852",
    "numero": 2352,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "A economia no consumo de combustível é um fator importante para a escolha de um carro. É considera-\ndo mais econômico o carro que percorre a maior distância por litro de combustível. O gráfico apresenta a \ndistância (km) e o respectivo consumo de gasolina (L) de cinco modelos de carros. \n \n \n \nO carro mais econômico em relação ao consumo de combustível é o modelo: \n \nA) A. \nB) B. \nC) C. \nD) D. \nE) E.",
    "alternativas": {
      "B": "B.",
      "C": "C.",
      "E": "E.",
      "A": "A."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 852,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0853",
    "numero": 2353,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "O padrão internacional ISO 216 define os tamanhos de papel utilizados em quase todos os países, com \nexceção dos EUA e Canadá. O formato-base é uma folha retangular de papel, chamada de A0, cujas \ndimensões são 84,1 cm x 118,9 cm. A partir de então, dobra-se a folha ao meio, sempre no lado maior, \nobtendo os demais formatos, conforme o número de dobraduras. Observe a figura a seguir: A1 tem o \nformato da folha A0 dobrada ao meio uma vez, A2 tem o formato da folha A0 dobrada ao meio duas ve-\nzes, e assim sucessivamente. \n \n \n \n(Disponível em: http://pt.wikipedia.org. Acesso em: 4 abr. 2012 - adaptado) \n \nQuantas folhas de tamanho A8 são obtidas a partir de uma folha A0? \n \nA) 8 \nB) 16 \nC) 64 \nD) 128 \nE) 256",
    "alternativas": {
      "B": "16",
      "C": "64",
      "E": "256",
      "A": "8"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 853,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0854",
    "numero": 2354,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "Para atrair uma maior clientela, uma loja de móveis fez uma promoção oferecendo um desconto de 20% \nem alguns de seus produtos. No gráfico, estão relacionadas as quantidades vendidas de cada um dos \nprodutos, em um dia de promoção. \n \n \n \nNo quadro constam os preços de cada produto vendido já com o desconto de 20% oferecido pela loja. \n \n \n \nQual foi o valor de desconto, em reais, concedido pela loja com a venda desses produtos durante esse \ndia de promoção? \n \nA) 300,00 \nB) 375,00 \nC) 720,00 \nD) 900,00 \nE) 1125,00",
    "alternativas": {
      "C": "720,00",
      "D": "900,00",
      "A": "300,00",
      "B": "375,00"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 854,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0855",
    "numero": 2355,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "O governo de um estado irá priorizar investimentos financeiros, na área de saúde, em uma das cinco \ncidades apresentadas na tabela. \n \nA cidade a ser contemplada será aquela que apresentar a maior razão entre número de habitantes e \nquantidade de médicos. \n \n \n \nQual dessas cidades deverá ser contemplada? \n \nA) M \nB) X \nC) Y \nD) Z \nE) W",
    "alternativas": {
      "D": "Z",
      "E": "W",
      "A": "M",
      "C": "Y"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 855,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  }
];